<template>
  <div>
    <!-- <button @click="getBtn" v-if="true">执行调用</button> -->
    <router-view></router-view>
  </div>
</template>

<script>
import axios from "axios";
// import { Littlehow } from "../assets/js/aa";
// var num = 10;
export default {
  name: "app",
  data() {
    return {
      num: 0,
      btnLength: null,
      btnGroup: null,
      btnArr: [],
    };
  },
  created() {
    
  },
  methods: {
    // getBtn() {
    //   for (let i = 0; i < this.btnGroup.length; i++) {
    //     // console.log(this.btnGroup[i].name);
    //     if (this.btnGroup[i].name != "我的信息") {
    //       // console.log(this.btnGroup[i].children);
    //       for (let j = 0; j < this.btnGroup[i].children.length; j++) {
    //         this.btnArr.push({
    //           name: this.btnGroup[i].children[j].name,
    //           btnArr: this.btnGroup[i].children[j].children,
    //         });
    //       }
    //     }
    //   }
    //   this.$store.commit("setBtnArr", this.btnArr);
    // },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/app.vue